export default __webpack_public_path__ + "static/media/inventory.1a434b24.png";